import graphqlClient from "../../../apollo";

class LocationProvider {

    findLocation(id) {
        return graphqlClient.query({
            query: require('./gql/Location/findLocation.graphql'),
            variables: {id:id}
        })
    }

    fetchLocation() {
        return graphqlClient.query({query: require('./gql/Location/fetchLocation.graphql')})
    }
    
    paginateLocation(pageNumber, itemsPerPage, search = null, filters = null,  orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/Location/paginateLocation.graphql'),
            variables: {pageNumber, itemsPerPage, search, filters, orderBy, orderDesc},
            fetchPolicy: "network-only"
        })
    }
    
    

    createLocation(input) {
        return graphqlClient.mutate({
            mutation: require('./gql/Location/createLocation.graphql'),
            variables: {input}
        })
    }
    
    updateLocation(id,input) {
        return graphqlClient.mutate({
            mutation: require('./gql/Location/updateLocation.graphql'),
            variables: {id, input}
        })
    }
    
     deleteLocation(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/Location/deleteLocation.graphql'),
            variables: {id}
        })
    }

}

export default new LocationProvider()


